import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Droppable } from 'react-beautiful-dnd';
import BoardContext from '../../BoardContext';
const Tree = function Tree(props) {
    const { children } = props;
    const { prefixCls } = useContext(BoardContext);
    // const { droppableProps, renderClone } = columnsDragRender;
    return true ? (React.createElement(Droppable, { droppableId: "tree__--__fields", key: "tree" }, (droppableProvided) => (React.createElement("div", Object.assign({ ref: droppableProvided.innerRef, className: `${prefixCls}-customization-tree` }, (droppableProvided && droppableProvided.droppableProps)),
        children,
        droppableProvided && droppableProvided.placeholder)))) : (React.createElement("div", { className: `${prefixCls}-customization-tree` }, children));
};
Tree.displayName = 'Tree';
export default observer(Tree);
